import Client from '../../../../api/client';
import { inject } from 'aurelia-framework';

@inject(Client)
export class EventDataService {
    constructor(client) {
        this.client = client;
    }

    async getApiSettings() {
        const settings = await this.client.get('maps/google/apikey', true);
        return {
            apiKey: settings?.apiKey ?? '',
            language: settings?.language ?? 'de',
            mapId: settings?.mapId ?? '1bf5295b744a394a',
        };
    }

    async fetchEventCategoryDetails(modelId, id) {
        try {
            return await this.client.get(`${modelId}/${id}`, {});
        } catch (error) {
            console.error('Error fetching event category details:', error);
            return null;
        }
    }

    async fetchEventLocationDetails(modelId, id) {
        const data = { embeds: ['title', 'images', 'images.file'] };
        return await this.client.get(`${modelId}/${id}`, data);
    }
}
